import { render } from "./PvpMonitoringModal.vue?vue&type=template&id=3bc1ecd4&scoped=true"
import script from "./PvpMonitoringModal.vue?vue&type=script&lang=ts"
export * from "./PvpMonitoringModal.vue?vue&type=script&lang=ts"

import "./PvpMonitoringModal.vue?vue&type=style&index=0&id=3bc1ecd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bc1ecd4"

export default script